export enum TAnalysisGroup {
    InVitro = "In-Vitro",
    InVivo = "In-Vivo",
    EEG = "EEG",
    MEG = "MEG",
    ECG = "ECG"
}